export const TEXT = {
    ALL: 'ALL',
    PHOTOS: 'Photos',
    VIDEOS: 'Videos',
    SLIDESHOW: 'Slide Show',
    FILTER_VIEW: 'Filter View',
    NO_ITEMS_TO_DISPLAY: 'No items to display'
};